const hyperlinks = {
  myGitHub: 'https://github.com/uriStolar',
  myHackerRank: 'https://hackerrank.com/mixtek',
  myLinkedIn: 'https://www.linkedin.com/in/uri-stolar-b541a9a1',
  mySO: 'https://stackoverflow.com/users/6031849/uri-stolar',
  myBlog: 'https://notas.uristolar.com',
  GNUGPL: 'https://www.gnu.org/licenses/gpl-3.0.txt'
}

export default hyperlinks;